import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class Footer extends Component {
    constructor(element, options) {
        super(element, options)
        
        this.ref = {
            inner: null
        }
    }

    prepare() {
        
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        this.update()
    }

    update() {
        if (!this.sizes) {
            this.resize()
        }
        
        const scrollY = Scroll.getScroll().y

        const ratio = (scrollY - this.state.documentTop) / (this.state.documentEnd - this.state.documentTop)

        if (ratio > 0 ) {
            this.element
        }
    }

    resize() {
        const rect = this.element.getBoundingClientRect()
        const scrollY = Scroll.getScroll().y
        this.state = {
            documentTop: scrollY + rect.top - Scroll.window.height,
            documentEnd: scrollY + rect.top + rect.height - Scroll.window.height,
        }
    }
}